<template>
  <pl-dialog
    size="dessassociate_sequence_roundtable"
    title="Delete RoundTable"
    @close="$emit('close')"
    :disableOutsideClick="true"
  >
    <div class="h-full w-full overflow-y-auto py-4">
      <div class="flex flex-col h-full">
        <div class="overflow-y-auto h-full px-5">
          <div class="text-gray-700">
            You are deleting
            <span class="font-semibold">{{ roundtable_name }}</span
            >. This cannot be undone and student data will be lost forever.
          </div>
        </div>
        <div class="flex flex-col px-5 flex-grow h-full">
          <div class="flex flex-col w-full space-y-1.5 mb-2">
            <span>Please type in "confirm" to delete</span>
            <input
              v-model="confirm_tag_delete"
              ref="confirm-input"
              @keyup.enter="handleDeleteRoundTable()"
              placeholder="Type 'confirm' to delete roundTable from the course"
              type="text"
              class="py-2 px-3 w-full border border-solid border-gray-200 bg-white rounded-md focus-within:border-red-500"
            />
          </div>
          <div class="flex items-center space-x-2">
            <button
              @click="$emit('close')"
              class="hover:bg-gray-50 bg-white py-2 flex items-center justify-center space-x-2 text-blueGray-500 font-medium w-full rounded-md border border-solid border-gray-200"
            >
              <span>Cancel</span>
            </button>
            <button
              @click="handleDeleteRoundTable()"
              class="bg-red-500 transition-colors py-2 flex items-center justify-center space-x-2 text-red-50 font-semibold w-full rounded-md border border-solid border-red-500"
            >
              <span>{{ is_deleting === true ? 'Deleting...' : 'Confirm'}}</span>
              <div v-if="is_deleting === true" class="loader"></div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </pl-dialog>
</template>
<script>
  import Vue from 'vue';
import { EventBus } from '../../../utils/event-bus';
  export default Vue.extend({
    props: {
      roundtable_name: String,
      roundtable_id: String,
    },
    data: () => ({
      is_deleting: false,
      confirm_tag: '',
      is_able_to_delete: false,
      show_error_message: false
    }),
    computed: {
      confirm_tag_delete: {
        get: function () {
          return this.confirm_tag;
        },
        set: function (newValue) {
          this.confirm_tag = newValue;
          if (this.confirm_tag === 'confirm') {
            this.is_able_to_delete = true;
            return;
          }
          this.is_able_to_delete = false;
          return;
        },
      },
    },
    methods: {
      handleDeleteRoundTable: async function (roundtable_id) {
        if (this.confirm_tag !== 'confirm') {
          const toast = {
            type: "Error",
            message: "Please type in 'confirm' to continue!",
            time: 5000
          };
          EventBus.$emit("createToast", toast);
          return;
        }
        if (this.is_able_to_delete === true) {
          this.is_deleting = true;
          this.$emit('delete_roundtable', roundtable_id);
        }
        return;
      },
    },
    mounted: async function() {
      this.$refs['confirm-input'].focus();
    }
  });
</script>



// WEBPACK FOOTER //
// DeleteRoundtableModal.vue?82013006